import Box from '@material-ui/core/Box'

import ClassificationPhoto from './ClassificationPhoto'
import StationPhoto from './StationPhoto'
import { styles } from './styles'

const TabPanel = (props) => {
  const { children, value, index } = props
  return (
    <div>
      {value === index && (
        <Box>
          <div>{children}</div>
        </Box>
      )}
    </div>
  )
}

const MostrarContenidoBox = ({ value, data, id, edit, img, setImg, imgEC, setImgEC }) => {
  const classes = styles()

  return (
    <div className={classes.style}>
      <TabPanel TabPanel value={value} index={0}>
        <ClassificationPhoto edit={edit} dialogData={data} id={id} img={img} setImg={setImg} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <StationPhoto edit={edit} dialogData={data} id={id} img={imgEC} setImg={setImgEC} />
      </TabPanel>
    </div>
  )
}

export default MostrarContenidoBox
